import escapeRegExp from "lodash/escapeRegExp";
import { useState, useMemo, useCallback } from "react";

const highlightMatch = (match) => `<mark>${match}</mark>`;

export const useSearchUtils = (searchTerm) => {
  const searchUtils = useMemo(() => {
    const strSearchTerm = (searchTerm || "").toString();
    const regExp = strSearchTerm
      ? new RegExp(escapeRegExp(strSearchTerm), "i")
      : null;

    const hasQuery = !!regExp;
    const match = (input) => !regExp || regExp.test(input);
    const highlightHit = (input) =>
      regExp && input ? input.replace(regExp, highlightMatch) : input;

    return { highlightHit, match, hasQuery };
  }, [searchTerm]);

  return searchUtils;
};

export const useSearch = (initialSearchTerm = "") => {
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
  const handleSearchTermChange = useCallback(
    (e) => setSearchTerm(e.target.value),
    []
  );

  const searchUtils = useSearchUtils(searchTerm);

  return { searchTerm, setSearchTerm, handleSearchTermChange, searchUtils };
};
